var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 4.66425V2.10938H20.4844C16.2393 2.10938 13.0955 3.82764 12 4.52087C10.9045 3.82764 7.76074 2.10938 3.51562 2.10938H2.8125V4.66443H0V21.9223H24V4.66425H21.1875ZM12.7031 5.74164C13.5456 5.20496 16.1907 3.71136 19.7812 3.53302V17.9854C16.6445 18.1269 14.1107 19.1845 12.7031 19.9512V5.74164ZM4.21875 3.5332C7.79517 3.71246 10.452 5.20715 11.2969 5.74274V19.9512C9.88934 19.1845 7.35553 18.1269 4.21875 17.9854V3.5332ZM1.40625 6.0705H2.8125V19.3757H3.51562C5.89288 19.3757 7.88544 19.9803 9.13824 20.4875C9.16187 20.497 9.18475 20.5065 9.20782 20.5161H1.40625V6.0705ZM22.5938 20.5161H14.7922C14.8152 20.5065 14.8381 20.497 14.8618 20.4875C16.1146 19.9803 18.1071 19.3757 20.4844 19.3757H21.1875V6.0705H22.5938V20.5161Z",
    fill: "#252B37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.4099e419fa8ed07f6713f00fff80193f.svg";
export { ForwardRef as ReactComponent };